import { render } from "./RichText.vue?vue&type=template&id=2abef4ea"
import script from "./RichText.vue?vue&type=script&lang=js"
export * from "./RichText.vue?vue&type=script&lang=js"

import "./RichText.vue?vue&type=style&index=0&id=2abef4ea&lang=scss"

import exportComponent from "/app/tmp/aft/V3/v2026.4.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__